module.exports = __webpack_public_path__ + "img/倒數開始_1.5a292685.png";